
import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import msLocale from '@fullcalendar/core/locales/ms';
import '@fullcalendar/daygrid/main.css';
import { useLocalization } from '../context/LocalizationContext';

// events: [{ title, date, classNames?, extendedProps? }]
export default function AvailabilityFullCalendar({
  events,
  onDateClick,
  onEventClick,
  validRange,
  dayCellClassNames,
}) {
  const { currentLanguage, t } = useLocalization();

  const handleDateClick = (info) => {
    if (onDateClick) onDateClick(info);
  };

  const handleEventClick = (info) => {
    if (onEventClick) {
      onEventClick(info);
      return;
    }
    // Fallback for day toggle flows that rely on event clicks.
    if (onDateClick) onDateClick({ date: info.event.start, event: info.event });
  };

  return (
    <FullCalendar
      plugins={[dayGridPlugin, interactionPlugin]}
      locales={[msLocale]}
      locale={currentLanguage === 'ms' ? 'ms' : 'en'}
      initialView="dayGridMonth"
      selectable={true}
      selectMirror={true}
      dayMaxEvents={true}
      events={events}
      dateClick={handleDateClick}
      eventClick={handleEventClick}
      validRange={validRange}
      dayCellClassNames={dayCellClassNames}
      height="auto"
      headerToolbar={{
        left: 'prev,next today',
        center: 'title',
        right: ''
      }}
      buttonText={{
        today: t('calendar_today', 'Today'),
      }}
      titleFormat={{ year: 'numeric', month: 'long' }}
    />
  );
}
